import React from "react";

import { useSelector } from 'react-redux';

import styles from "./PintrestShareLink.module.css";

import mainIcon from './assets/pinterest.svg'

const PintrestShareLink = () => {

    const shareData = useSelector((state) => state.visualizer.shareData);

    // Construct a social intent URL for sharing the link with the provided social share text
    const mediaURL = `https://renderfarm2.chameleonpower.com/proxy//GetImage.ashx?spec=` + encodeURIComponent(shareData.specifier) + `(focus=300)&sel=${shareData.sel}&Size=512&type=base`;
    const pintrestUrl = `https://www.pinterest.com/pin/create/button/?url=` + encodeURIComponent(shareData.url) + `&description=${shareData.message}&media=${mediaURL}`;
    return (
        <a href={pintrestUrl} target="_blank" rel="noopener noreferrer" aria-label="share to Pintrest link" className={styles.mainIcon}>
            <img src={mainIcon} alt="facebook icon" />
        </a>
    );
};

export default PintrestShareLink;